<template>
	<footer class="footer" v-if="$route.name !=  'ticket'">
		<div class="container">


			<div class="copyright">
				<b>&copy; {{ new Date().getFullYear() }}</b>. All rights reserved by <b><span class="text-primary">AIR &TECH SHOW</span></b>
			</div>
			<div class="copyright text-center">
				<!-- <div class="md-layout-item md-small-size-100 md-size-100">
					<img src="@/assets/img/sponsor.png" />
				</div> -->
				<!-- System by <span class="text-primary"><b>Ministry of Industry, Science, Technology & Innovation</b></span> -->
			</div>
		</div>
	</footer>
</template>

<script>
	export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Layout/ContentFooter.vue